import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value", "disabled"]
const _hoisted_2 = ["name"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _normalizeProps(_guardReactiveProps({..._ctx.$attrs, ..._ctx.$props})), _createSlots({
    default: _withCtx(() => [
      _createElementVNode("label", {
        class: _normalizeClass(['gfu-field-switch', { 'gfu-field-switch--left': $props.labelPosition === 'left' }, { 'gfu-field-switch--small': _ctx.small }]),
        tabindex: "0",
        onBlur: _cache[1] || (_cache[1] = (...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
        "data-qa": "switch-field-label"
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.checkboxValue) = $event)),
          class: "gfu-field-switch__input",
          type: "checkbox",
          value: _ctx.model,
          disabled: $options.isDisabled,
          "data-qa": "switch-field-input"
        }, null, 8 /* PROPS */, _hoisted_1), [
          [_vModelCheckbox, $data.checkboxValue]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(['gfu-field-switch__slider', {'gfu-field-switch__slider--readonly': _ctx.readOnly, 'gfu-field-switch__slider--left': $props.labelPosition === 'left'}]),
          name: _ctx.name,
          "data-qa": "switch-field-slider"
        }, [
          _renderSlot(_ctx.$slots, "slider")
        ], 10 /* CLASS, PROPS */, _hoisted_2),
        _createElementVNode("span", {
          class: _normalizeClass(['gfu-field-switch__label', {'gfu-field-switch__label--readonly': _ctx.readOnly, 'gfu-field-switch__label--left': $props.labelPosition === 'left'}])
        }, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString($options.label), 1 /* TEXT */)
          ])
        ], 2 /* CLASS */)
      ], 34 /* CLASS, NEED_HYDRATION */)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots.description)
      ? {
          name: "field-description",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "description")
          ]),
          key: "0"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
}